const FBMCouriers = {
  FEDEX: 'Fedex',
  INT99MINUTOS: '99Minutos',
  FEDEX_US: 'FedexUS',
  SHIPSMART: 'Shipsmart',
  LAPCOURIER: 'LAPCourier',
};

export default FBMCouriers;
